import m from 'mithril';
import modalCloseButton from '../../../components/modalCloseButton';

var props
const modal = {
  key: 'USER_AUTH_MODAL',

  show(props) {
    $(`#${modal.key}`).modal('show');
    props = props
  },
  hide() {
    $(`#${modal.key}`).modal('hide');
  },
  oninit({ state }) {
    state.loading = false;
  },
  view({ state, attrs }) {
    return m('.modal', { id: modal.key },
      [
        m('.modal-dialog[role="document"]',{style:{"max-width":"1000px"}},
          [
            m('.modal-content',
              [
                m('.modal-header',
                  [
                    // m('h1.modal-title', props.title),
                    m("div", { "class": "btn btn-icon btn-sm btn-active-light-primary ms-2", "data-bs-dismiss": "modal", "aria-label": "Close" },
                      m(modalCloseButton)
                    )
                  ]),
                m('.modal-body',
                  [
                    m("div", { "class": "section d-flex justify-content-center embed-responsive embed-responsive-4by3", "id": "trailer" },
                      m("video", { "class": "embed-responsive-item", "controls": "controls", "autoplay": "autoplay", "loop": "loop", "muted": "muted" },
                        [
                          m("iframe", {"width":"560","height":"315","src":"https://www.youtube.com/embed/xBjR2NROui4?si=MdgCD-UBeUA5NLn1","title":"YouTube video player","frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share","referrerpolicy":"strict-origin-when-cross-origin","allowfullscreen":false})
                        ]
                      )
                    )
                  ]),
                m('.modal-footer',
                  [

                    m('button.btn.btn-primary[type="button"]', {
                      onclick() {
                        
                        state.loading = true;
                        m.redraw();
                        // some async tings
                        setTimeout(() => {
                          // Create new driver logic goes here
                          console.log(`Created new driver: ${state.driverName} - ${state.driverPhoneNumber}`);
                          state.loading = false;
                          m.redraw();
                          modal.hide();
                        }, 2000);
                      },
                    }, 'Continue'),
                  ]),
              ]),
          ]),
      ]);
  },
};


export default modal;
